import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import App from './App.vue'
import router from './router'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import 'sweetalert2/dist/sweetalert2.min.css';
import scrollRevealPlugin from './directives/scrollReveal.js';
import ThaiSupportPlugin from './plugins/thai-support.js';
import PerformanceOptimizationPlugin from './plugins/performance-optimization.js';
import { initBrowserCompatibility } from './utils/browser-compatibility.js';
import { preloadImages } from './utils/image-optimization.js';

// Initialize browser compatibility detection and fallbacks
const compatibilityInfo = initBrowserCompatibility();

// Preload critical images
const criticalImages = [
  // Add critical image URLs here
  '/images/logo.png',
  '/images/hero-bg.jpg'
];

// Only preload if not on slow connection
if (!('connection' in navigator) || 
    (navigator.connection.effectiveType !== 'slow-2g' && 
     navigator.connection.effectiveType !== '2g' && 
     !navigator.connection.saveData)) {
  preloadImages(criticalImages, { priority: 'high' });
}

const pinia = createPinia()
const app = createApp(App)

// Make compatibility info available globally
app.config.globalProperties.$browserCompat = compatibilityInfo;

app.use(pinia)
app.use(router)
app.use(scrollRevealPlugin)
app.use(ThaiSupportPlugin, {
    registerDirectives: true,
    registerGlobalProperties: true,
    registerComponents: false
})
// app.use(new PerformanceOptimizationPlugin({
//     enableResourceOptimization: true,
//     enableBundleOptimization: true,
//     enablePerformanceMonitoring: true,
//     enableMemoryOptimization: true
// }))
app.use(Toast, {
    position: "top-right",
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false
});

// Performance monitoring setup
if (process.env.NODE_ENV === 'development') {
}

app.mount('#app')
